import { ActionCreator } from "redux";
import {
  AuthenticateUserAction,
  ChangeLoginInformationAlreadySubmissionStateAction,
  ToggleInvalidLoginAction,
  ToggleMyleCommunicationIssuesStateAction
} from "./type";
import {
  SET_VALID_LOGIN_STATUS,
  SET_ALREADY_SUBMITTED_STATE,
  AUTHENTICATE_USER,
  SET_COMMUNICATION_ERROR_STATUS
} from "./constants";


export const authenticateUser: ActionCreator<AuthenticateUserAction> = (isAuthenticated: boolean) => ({
    type: AUTHENTICATE_USER,
    payload: {
        isAuthenticated
    },
});

export const changeLoginInformationAlreadySubmissionState: ActionCreator<ChangeLoginInformationAlreadySubmissionStateAction> = (isAlreadySubmitted: boolean) => ({
    type: SET_ALREADY_SUBMITTED_STATE,
    payload: {
        isAlreadySubmitted
    },
});

export const toggleValidLoginStatus: ActionCreator<ToggleInvalidLoginAction> = (isValid: boolean) => ({
    type: SET_VALID_LOGIN_STATUS,
    payload: {
        isValid
    },
});

export const toggleMyleCommunicationIssuesState: ActionCreator<ToggleMyleCommunicationIssuesStateAction> = (isHavingIssuesWithConnectionToMyle: boolean) => ({
    type: SET_COMMUNICATION_ERROR_STATUS,
    payload: {
        isHavingIssuesWithConnectionToMyle
    }
})


// WEBPACK FOOTER //
// ./src/store/Login/actions.ts